import React from 'react';
/* import DropdownTreeSelect from 'react-dropdown-tree-select';
import isEqual from 'lodash/isEqual' */
import TreeView from './TreeView';

const CategorieWebSub = ({ data, onChange, categorie }) => {
  return (
    <TreeView data={data} onChange={onChange} categorie={categorie} />
  );
};

export default CategorieWebSub;